/**
 * @fileoverview Agent definition for chapter-drafter-comparison-v2.
 *
 * This is a COMPOSITE agent that runs chapter-drafter-v2 in parallel with
 * different models (up to 3) to allow comparison of outputs.
 *
 * Use case: From the AI control panel, users can run up to three chapter-drafter
 * agents in parallel to compare them against each other.
 *
 * @category writing.content.comparison
 * @type composite
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-drafter-comparison-v2',
  kind: 'composite',
  name: 'Chapter Drafter Comparison',
  description: 'Runs chapter drafter with multiple AI models in parallel for side-by-side comparison.',
  category: 'writing',
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata ---
  metadata: {
    status: 'active',
    type: 'composite',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    usedBy: [
      'use-chapter-drafter-comparison-v2.ts',
      'CompareContentPanel',
    ],
    // This composite runs the same primitive multiple times with different models
    composedOf: [
      'chapter-drafter-v2',
      'single-chapter-drafter',
    ],
    relatedAgents: ['chapter-drafter-v2', 'single-chapter-drafter', 'prose-comparer-v2'],
    taxonomyPath: 'writing.content.comparison',
  },
};
